import * as React from "react";
import { Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { debounce } from "lodash-es";
import { IoSearchOutline } from "react-icons/io5";
import { useQueryParams } from "duck";

const Search: React.FC = () => {
  const [params, setParams] = useQueryParams();
  const debouncedSetParams = debounce(setParams, 400);

  return (
    <InputGroup>
      <InputLeftElement color="gray.400">
        <IoSearchOutline />
      </InputLeftElement>
      <Input
        defaultValue={params.search}
        onChange={event => {
          const newSearch = event.target.value;
          debouncedSetParams(
            {
              ...params,
              pagination: { page: 1 },
              search: newSearch
            },
            { replace: true }
          );
        }}
        placeholder="Search"
        _placeholder={{ color: "gray.400" }}
      />
    </InputGroup>
  );
};

export default Search;
